import { Box } from 'styled-system/jsx';
import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import { CorrectiveSelectedImageBarType } from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/correctiveSelectedImageBar/CorrectiveSelectedImageBar.type';
import { useMemo } from 'react';
import { DamagedVehicleCorrectiveImageNameType } from '@/modules/adjusterReportModules/IncidentParticipants/types/images';
import BodyCorrectiveSelectedImageBarList from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyCorrectiveSelectedImageBarList/BodyCorrectiveSelectedImageBarList';
const BodyInquiredFormList = () => {
  const {
    selectedDamagedParts,
    selectedDocuments,
    selectedVehicle,
    removeSelectedDamagedParts,
    removeSelectedDocuments,
    removeSelectedVehicle,
  } = useCorrectiveImages();
  const Points: CorrectiveSelectedImageBarType[] = useMemo(() => {
    const tempDamaged = selectedDamagedParts.map((item) => ({
      id: item.name,
      title: `${item.name} - ${item.type}`,
      removePoint: () => removeSelectedDamagedParts(item.name),
      type: DamagedVehicleCorrectiveImageNameType.damaged_parts,
      editable: true,
    }));
    const tempDocs = selectedDocuments.map((item) => ({
      id: item.name,
      title: `${item.name} - ${item.type}`,
      removePoint: () => removeSelectedDocuments(item.name),
      type: DamagedVehicleCorrectiveImageNameType.documents,
      editable: true,
    }));
    const tempVehicle = selectedVehicle.map((item) => ({
      id: item.name,
      title: `${item.name} - ${item.type}`,
      removePoint: () => removeSelectedVehicle(item.name),
      type: DamagedVehicleCorrectiveImageNameType.vehicle,
      editable: true,
    }));
    return [...tempDamaged, ...tempDocs, ...tempVehicle];
  }, [selectedDamagedParts, selectedDocuments, selectedVehicle]);
  return (
    <Box
      display="flex"
      alignItems={'flex-start'}
      h={400}
      mt={32}
      borderRadius={8}
      border="1px dashed"
      borderColor="gray-1"
      overflow="auto"
    >
      <BodyCorrectiveSelectedImageBarList points={Points} />
    </Box>
  );
};

export default BodyInquiredFormList;
